import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
// import { renderRoutes } from 'react-router-config';
import Loadable from 'react-loadable';
import './App.scss';
import store from './redux/store';
import { loadUser } from './redux/actions/auth';
import ForgotPassword from './views/Pages/ForgotPassword/forgotPassword';
import ResetPassword from './views/Pages/ResetPassword/resetPassword';
import ForgotUsername from './views/Pages/ForgotUsername/forgotUsername';

const loading = () => <div className="animated fadeIn pt-3 text-center"><div className="sk-spinner sk-spinner-pulse"></div></div>;

// Containers
const DefaultLayout = Loadable({
  loader: () => import('./containers/DefaultLayout'),
  loading
});

// Pages
const Login = Loadable({
  loader: () => import('./views/Pages/Login'),
  loading
});

class App extends Component {

  componentDidMount() {
    store.dispatch(loadUser());
  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/login" name="Login Page" component={Login} />
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/forgot-username" component={ForgotUsername} />
          <Route exact path="/reset-password/:uid/:token" component={ResetPassword} />
          <Route path="/" name="Home" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
